<template>
  <v-modal :open="isControlled ? open : show" @close="close()">
    <div class="v-announce">
      <v-slider
        @slideChange="onSlideChange()"
        @init="onSliderInit()"
        :navigation="false"
        :pagination="true"
        ref="slider">
        <slot />
      </v-slider>
      <div
        v-if="initialized"
        class="text-right mt-4">
        <v-button class="mr-3" inverted v-if="1 < step" @click="previous()">
          {{ $t('Previous', 'components.announce.previous')}}
        </v-button>
        <v-button v-if="step < totalSteps" @click="next()">
          {{ $t('Next', 'components.announce.next')}}
        </v-button>
        <v-button v-else @click="close()">
          {{ $t('Finish', 'components.announce.finish')}}
        </v-button>
      </div>
    </div>
  </v-modal>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: null
    },
    announcementId: {
      type: String,
      default: null
    }
  },
  computed: {
    isControlled() {
      return this.$props.open === true || this.$props.open === false;
    }
  },
  data() {
    return {
      initialized: false,
      show: false,
      step: 1
    };
  },
  mounted() {
    this.totalSteps = this.$slots.default.filter(
      c => c.componentOptions && c.componentOptions.tag === "v-announce-step"
    ).length;

    if (!this.isControlled && !this.hasBeenShown()) {
      this.show = true;
      this.saveAsShown();
    }
  },
  methods: {
    slider() {
      return this.initialized ? this.$refs.slider.swiper : false;
    },
    onSliderInit() {
      this.initialized = true;
    },
    onSlideChange() {
      this.step = this.slider().activeIndex + 1;
    },
    previous() {
      this.slider() && this.slider().slidePrev();
    },
    next() {
      this.slider() && this.slider().slideNext();
    },
    close() {
      this.show = false;
      this.$emit("close");
      setTimeout(_ => this.slider().slideTo(0, 0), 250);
    },
    saveAsShown() {
      if (!this.announcementId) return;
      localStorage.setItem(
        "shownAnnouncements",
        JSON.stringify([...this.shownAnnouncements(), this.announcementId])
      );
    },
    hasBeenShown() {
      if (!this.announcementId) return false;
      return this.shownAnnouncements().includes(this.announcementId);
    },
    shownAnnouncements() {
      return JSON.parse(localStorage.getItem("shownAnnouncements")) || [];
    }
  }
};
</script>

<style global lang="scss">
@import "../../sass/component.scss";
</style>
